import moment from "moment";
import { ExportService } from "..";
import { ReportSettingsModel } from "../exportModels";
import { ReportPanelBodyBaseState } from "./reportPanelBodyBase";

function stringifyStateReportSettings(state: ReportPanelBodyBaseState): string {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { loadingReportSettingsJSONStrings, ...stateReportSettings } = state;
  return JSON.stringify(stateReportSettings);
}

function tryParseReportSettings(settings: string): Record<string, unknown> {
  if (settings) {
    try {
      return JSON.parse(settings);
    } catch (e) {
      console.error(`Unable to parse Report Settings JSON. ${e}`);
      return null;
    }
  }  
}

function reportName(prefix: string): string {
  const now = moment();
  return `${prefix}_${now.format("YYYYMMDD[_]HHmmss")}`;
}

const saveNewReportSettings = async (rs: ReportSettingsModel): Promise<ReportSettingsModel> => {
  const exportService = new ExportService();
  return await exportService.saveReportSettings(rs);
}

const saveUpdatedReportSettingsList = async (rs: ReportSettingsModel[]): Promise<boolean> => {
  const exportService = new ExportService();
  return await exportService.updateReportSettings(rs);
}

const deleteReportSettings = async (ids: number[]): Promise<boolean> => {
  const exportService = new ExportService();
  return await exportService.deleteReportSettings(ids);
}

export {
  deleteReportSettings,
  saveNewReportSettings,
  saveUpdatedReportSettingsList,
  stringifyStateReportSettings,
  tryParseReportSettings,
  reportName,
};
